import { addArtToCart, addWallToCart, addWallPicturesToCart } from 'arts/actions/cart_items';
import { whenSaved } from './save_wall';

const framesByWallPictureId = (works) => works.reduce((acc, w) => (
  w.wallPictureId ? { ...acc, [w.wallPictureId]: !!w.frameId } : acc
), {});

// The works the ART INFO panel hands over are a selector snapshot: anything the user added
// since the last save round-trip has no wallPictureId on it yet. Re-read the live canvas by
// `key` (stable across canvas:assignIds) so those items pick up the id the flushed save just
// assigned, instead of being silently dropped from the payload.
const withCurrentIds = (works, canvasWorks) => {
  const byKey = {};
  canvasWorks.forEach((w) => { byKey[`${ w.key }`] = w; });
  return works.map((w) => byKey[`${ w.key }`] || w);
};

// Adds one canvas item. Goes through the wall-picture endpoint whenever the row
// exists server-side, so the item keeps its source wall attribution and can still
// complete its wall's discount in the cart.
export const addToCart = (index) => (dispatch, getState) => {
  const { canvas: { works }, workDetails } = getState();
  const work = works[index];
  const {
    workId, workSizeId, frameId, nonGlare, wallPictureId
  } = work;
  if (wallPictureId) {
    dispatch(addWallPicturesToCart(framesByWallPictureId([work]), null));
    return;
  }
  const { paperId } = workDetails[workId].workSizes.find((ws) => ws.id === workSizeId);
  dispatch(addArtToCart({
    frameId, paperId, workId, nonGlare
  }));
};

export const addWallGroupToCart = (groupWorks, sourceWallId) => (dispatch, getState) => (
  whenSaved().then(() => {
    const frames = framesByWallPictureId(withCurrentIds(groupWorks, getState().canvas.works));
    // An empty map is not "add nothing": CartItemsController treats a blank wall_picture_ids
    // as "not a wall request" and falls through to the plain cart_item branch, which builds
    // an item with no work, paper or kind (and saves an empty order on the way).
    if (!Object.keys(frames).length) {
      return;
    }
    dispatch(addWallPicturesToCart(frames, sourceWallId));
  })
);

export const addCurrentWallToCart = () => (dispatch, getState) => {
  const { canvas: { wallId } } = getState();
  dispatch(addWallToCart(wallId));
};
